import React from "react";
import { useSdkContext } from "scmp-sdk/components/contexts";
import { useNewsletterContext } from "scmp-sdk/components/newsletter/newsletter-widget/contexts";
import { getNewsletterTitle } from "scmp-sdk/components/newsletter/newsletter-widget/sign-up-newsletter/helpers";

import SvgGlobalImpact from "./img-global-impact.svg";
import SvgLunar from "./img-lunar.svg";
import SvgPostMag from "./img-post-mag.svg";
import SvgThisWeekInAsia from "./img-twia.svg";
import { StyledSvgIconEnvelope } from "./styles";

export const ArticleThemeTitle: React.FunctionComponent = () => {
  const { config } = useSdkContext();
  const { newsletterItemForDisplay } = useNewsletterContext();

  const newsletterSvgMap = {
    [config.newsletter.globalImpact]: <SvgGlobalImpact />,
    [config.newsletter.lunar]: <SvgLunar />,
    [config.newsletter.postMag]: <SvgPostMag />,
    [config.newsletter.thisWeekInAsia]: <SvgThisWeekInAsia />,
  };

  const computedNewsletterTitle = getNewsletterTitle(newsletterItemForDisplay);
  const newsletterId = newsletterItemForDisplay?.entityId ?? "";

  if (newsletterId in newsletterSvgMap) {
    return (
      <>
        {newsletterSvgMap[newsletterId]}
        <StyledSvgIconEnvelope />
      </>
    );
  }

  return <>{computedNewsletterTitle}</>;
};

ArticleThemeTitle.displayName = "ArticleThemeTitle";
